const AlbumFilesSettings = {
  MAX_SIZE_MB: 10,
  ALLOWED_FILE_EXTENSIONS: ["png", "jpeg", "jpg", "pdf", "doc", "docx"]
}

export { AlbumFilesSettings }
